import { z } from "zod/v4";

export const ShippingActionList = [
  "create",
  "start",
  "pause",
  "end",
  "delete",
  "reset",
] as const;

export type ShippingActionType = (typeof ShippingActionList)[number];

export const ShippingSettingsSchema = z.object({
  autoRestore: z.boolean().default(true),
  numLocationGroupZoneResults: z.number().optional().default(1),
  numMethodDefinitionResults: z.number().optional().default(1),
});

export type ShippingSettingsType = z.infer<typeof ShippingSettingsSchema>;

export const ShippingRestoreFailureSchema = z.object({
  methodName: z.string(),
  reason: z.string(),
});

export type ShippingRestoreFailure = z.infer<
  typeof ShippingRestoreFailureSchema
>;

export const ShippingLocationDtoSchema = z.object({
  country: z.string().nullish(),
  postal_code: z.string().nullish(),
  province: z.string().nullish(),
  city: z.string().nullish(),
  name: z.string().nullish(),
  // intermittently gets sent as an object, we don't use this property so no need to validate
  address1: z.any().nullish(),
  address2: z.any().nullish(),
  address3: z.any().nullish(),
  latitude: z.number().nullish(),
  longitude: z.number().nullish(),
  phone: z.string().nullish(),
  fax: z.string().nullish(),
  email: z.string().nullish(),
  address_type: z.string().nullish(),
  company_name: z.string().nullish(),
});

export const ShippingLineItemDtoSchema = z.object({
  name: z.string().nullish(),
  sku: z.string().nullish(),
  quantity: z.number(),
  grams: z.number(),
  price: z.number(),
  vendor: z.string().nullish(),
  requires_shipping: z.boolean(),
  taxable: z.boolean().nullable(),
  fulfillment_service: z.string().nullish(),
  properties: z.record(z.string(), z.any()).nullish(),
  product_id: z.number().nullish(),
  variant_id: z.number().nullish(),
});
